import React from 'react';
import { BookOpenCheckIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-navy-950 text-white" data-id="element-65">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:py-5" data-id="element-66">
        <a href="#inicio" className="flex items-center gap-2 text-sm font-extrabold tracking-tight sm:text-base" data-id="element-67">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gold-300 text-navy-950" data-id="element-68">
            <BookOpenCheckIcon size={18} data-id="element-69" />
          </span>
          ESL TEACHER <span className="text-gold-300" data-id="element-70">READY</span>
        </a>
        <div className="hidden items-center gap-5 text-xs font-semibold text-blue-100 lg:flex" data-id="element-71">
          <span className="flex items-center gap-1.5" data-id="element-72">
            <ShieldCheckIcon size={15} className="text-gold-300" data-id="element-73" /> 7-day
            guarantee
          </span>
          <span className="flex items-center gap-1.5" data-id="element-74">
            <LockKeyholeIcon size={15} className="text-gold-300" data-id="element-75" /> Secure
            payment
          </span>
          <span className="flex items-center gap-1.5" data-id="element-76">
            <ZapIcon size={15} className="text-gold-300" data-id="element-77" /> Instant access
          </span>
        </div>
        <a href="#offer" className="rounded-lg border border-gold-300 px-3 py-2 text-xs font-extrabold text-gold-100 transition hover:bg-gold-300 hover:text-navy-950" data-id="element-78">
          GET ACCESS
        </a>
      </div>
    </header>;
}